const keyMap = {
    angry: 'reaction.angry',
    clap: 'reaction.clap',
    surprised: 'reaction.wow',
    thinking: 'reaction.curious',
    lol: 'reaction.haha',
    heart: 'reaction.love',
    sad: 'reaction.sad',
    thumbsup: 'reaction.thumbs_up',
    smiley: 'reaction.smiley',
};
export const getReactionKeyByName = (name) => {
    return keyMap[name];
};
//# sourceMappingURL=get-reaction-key.js.map